import { ModalContentContainer, ModalBody, ModalFooter } from "../../Modal/index";

export const Info = () => {
    return (
      <ModalContentContainer>
        <ModalBody
          title="Air Quality Compliance Interactive Map"
          customStyle="sm:w-3/4"
        >
          <p className="text-sm py-2 sm:py-0 sm:text-xl">
            This interactive tool allows you to explore air quality data that
            makes up the UK's annual air quality compliance assessment.
          </p>
          <p className="text-sm py-2 sm:py-0 sm:text-base">
            Users can view and download compliance data by zone and agglomeration
            (the UK is divided into 43 zones for air quality assessment) or by
            Local Authority. The UK is assessed against different limit values
            (LV), target values (TV), long term objectives (LTO) and critical levels
            (CL) for various pollutants. You can find out more about these limits
            and objectives{" "}
            <a className="text-blue-600 underline" href="https://uk-air.defra.gov.uk/air-pollution/uk-eu-limits">
              here
            </a>
            .
          </p>
          <p className="text-sm py-2 sm:py-0 sm:text-base">
            UK level data can be downloaded using the Air Quality Compliance Data
            Hub{" "}
            <a className="text-blue-600 underline" href="https://compliance-data.defra.gov.uk">
              here
            </a>
            .
          </p>
          <p className="text-sm py-2 sm:py-0 sm:text-base">
            Licencing information can be viewed <a className="text-blue-600 underline" href="https://uk-air.defra.gov.uk/data/gis-licences">here</a>. 
          </p>
          <p className="text-sm py-2 sm:py-0 sm:text-base">
            <span className="font-bold">Need help using this tool?</span><br/> 
            For any questions about this tool, please contact <a className="text-blue-600 underline" href="mailto:aqinfo@ricardo.com">aqinfo@ricardo.com</a>.
          </p>
          <h2 className="text-base py-2 sm:py-0 sm:text-3xl font-bold w-3/4">
            To view or download compliance data, answer the following questions
          </h2>
        </ModalBody>
        <ModalFooter submitButtonLabel="Start the wizard" />
      </ModalContentContainer>
    );
  };